module.exports = __webpack_public_path__ + "static/media/ds1.40216c88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/displayBoard/ds1.svg
// module id = 1199
// module chunks = 0